import { fmtDMYTime } from './ui/dates';
/** The ready-to-send invite email the admin copies after creating a user. */
export function welcomeUrl(token: string) { return `${location.origin}/welcome/${token}`; }
export function manualUrl() { return `${location.origin}/manual`; }

export function inviteEmail(o: { name: string; email: string; token: string; expiresAt: string; adminName?: string }) {
  const expires = fmtDMYTime(o.expiresAt);
  const subject = 'Your Bhorosha account is ready';
  const body = `Hi ${o.name || 'there'},

You have been given an account on Bhorosha — one place for your family's medicines, injection reminders, doctor visits and test results.

1. Set your password and sign in (this link works once, until ${expires}):
${welcomeUrl(o.token)}

2. New to Bhorosha? Read the short guide first:
${manualUrl()}

Your sign-in email: ${o.email}

If the link has expired, just reply and I'll send you a new one.

${o.adminName ? `— ${o.adminName}, ` : '— '}Bhorosha admin`;
  return { subject, body, full: `Subject: ${subject}\n\n${body}`, expires, link: welcomeUrl(o.token), manual: manualUrl() };
}

const when = (iso: string) => fmtDMYTime(iso);

/** The message the admin sends with a one-time password. */
export function tempPasswordMessage(o: { name: string; email: string; password: string; expiresAt: string; adminName?: string }) {
  const expires = when(o.expiresAt);
  const site = location.origin;
  const subject = 'Your Bhorosha sign-in details';
  const body = `Hi ${o.name || 'there'},

Your Bhorosha account is ready. Sign in here:
${site}

Email: ${o.email}
One-time password: ${o.password}

This password works until ${expires}. After you sign in, you'll choose your own password.

New to Bhorosha? Read the short guide first:
${manualUrl()}

${o.adminName ? `— ${o.adminName}, ` : '— '}Bhorosha admin`;
  return { subject, body, full: `Subject: ${subject}\n\n${body}`, expires, site, manual: manualUrl() };
}
